import { readonly, ref } from 'vue'

import type { ConfirmOptions, ConfirmState } from '@/types/interfaces/ui'

const state = ref<ConfirmState>({ isOpen: false, message: '' })
let resolver: ((ok: boolean) => void) | undefined

/** @returns 확인 true / 취소 false */
function confirm(options: ConfirmOptions): Promise<boolean> {
  // 이전 다이얼로그가 떠 있으면 취소로 정리한다
  resolver?.(false)
  state.value = { ...options, isOpen: true }
  return new Promise<boolean>((resolve) => {
    resolver = resolve
  })
}

function alert(message: string, title?: string): Promise<boolean> {
  return confirm({ message, title, alertOnly: true })
}

function respond(ok: boolean) {
  state.value = { ...state.value, isOpen: false }
  resolver?.(ok)
  resolver = undefined
}

export function useConfirm() {
  return {
    confirmState: readonly(state),
    confirm,
    alert,
    accept: () => respond(true),
    reject: () => respond(false),
  }
}
